module.exports = __webpack_public_path__ + "static/media/9.9b9cb7a1.png";